module.exports = __webpack_public_path__ + "static/media/mustard.099acbc3.png";